import RollingLoadingIcon from '@/common/assets/icons/rollingLoadingIcon.svg?react';
import UploadIcon from '@/common/assets/icons/uploadImage.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import CompletingImages from '@/common/components/camera/components/completingImages/CompletingImages';
import { UploadImageCardPropsType } from '@/common/components/uploadImage/attachedUploadImageCard/AttachedUploadImageCard.type';
import useModal from '@/common/hooks/useModal';
import { Box, Flex } from 'styled-system/jsx';
import { gridItem } from 'styled-system/patterns';

const AttachedUploadImageCard = ({
  title,
  onUploadImage,
  uploadImageLoading,
  totalImages,
  addImageOnClick,
}: UploadImageCardPropsType) => {
  const { closeModal, open, openModal } = useModal();

  const onClick = () => (addImageOnClick ? addImageOnClick : openModal);

  return (
    <Box
      backgroundColor="white"
      borderRadius="8px"
      className={gridItem({ rowSpan: 1 })}
    >
      <>
        <Flex
          onClick={uploadImageLoading ? undefined : onClick()}
          justifyContent="center"
          alignItems="center"
          height="112px"
        >
          {uploadImageLoading ? (
            <RollingLoadingIcon width={60} />
          ) : (
            <UploadIcon />
          )}
        </Flex>
        <Flex
          h="40px"
          borderTop="1px solid"
          borderColor="gray-3"
          justifyContent="center"
          alignItems="center"
        >
          <Typography color="black-1" textStyle="b4">
            {title}
          </Typography>
        </Flex>
      </>

      {open && (
        <CompletingImages
          onDenyCamera={() => {}}
          onCompleteImages={(img) => {
            onUploadImage({
              imageData: img.map((item) => ({
                blob: item.blob!,
                url: item.url,
              })),
              closeModal,
            });
            closeModal();
          }}
          maxTotalImages={totalImages}
          closeCamera={closeModal}
        />
      )}
    </Box>
  );
};
export default AttachedUploadImageCard;
